// Assuming Inventory is the default export from './Inventory'
import Inventory from './Inventory';

// Export it as a named export
export default Inventory;
